// removed by extract-text-webpack-plugin
module.exports = {"base-button":"_1N7YyLG1Cz1wb97TtJFCgd","a-button":"_3ky21-ruyLZKuEmHDTBsh","a-button--inline":"_2qMLmLUjfF1u0Nn6oroGg","base-disabled-button":"_1bgtBF_S2SBBnBibKcWj3I","a-button--primary":"Zjy-Sy9ieAYrtb3DZWbCd","a-button--secondary":"_16yx57e6T0pj3QguKJGcTX","a-button--secondary-auto":"crqPYrK-tFj3NAeBvy8G","a-button--secondary-small":"_3BSr5pyBQ-b2T7XJbX4OwS","a-button--tertiary":"AU6EkhD_Z3vI1DtWGfo0N","a-button--quaternary":"_17_-DJufd9FUWkKZ5DR5do"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/FormInput/ButtonStyle.scss
// module id = 414
// module chunks = 0